<template>
  <AGAutocomplete
    v-model="localValue"
    label="Status de análise"
    item-title="text"
    item-value="value"
    :items="items"
    :hint="hint"
    :disabled="disabled"
    :multiple="multiple"
    :has-select-all="hasSelectAll"
    :rules="rules"
    :message-color="messageColor"
  />
</template>

<script>
import AGAutocomplete from '@/components/common/AGAutocomplete.vue';
import { MESSAGE_COLOR } from '@/constants/ConstantMessageColor';
import STATUS_ANALISE from '@/constants/ConstantStatusAnalise';

export default {
  components: { AGAutocomplete },

  emits: ['update:modelValue'],

  props: {
    modelValue: {
      type: [Boolean, String, Number, Array, Object, null],
      required: true,
    },
    hint: {
      type: String,
      default: '',
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    rules: {
      type: Array,
      default: () => [],
    },
    hasSelectAll: {
      type: Boolean,
      default: false,
    },
    messageColor: {
      type: String,
      default: MESSAGE_COLOR.DEFAULT,
      validator: (val) => Object.values(MESSAGE_COLOR).includes(val),
    },
  },
  computed: {
    localValue: {
      get() {
        return this.modelValue;
      },
      set(val) {
        this.$emit('update:modelValue', val);
      },
    },
    items() {
      return Object.keys(STATUS_ANALISE).map((status) => ({
        text: this.getLabel(status),
        value: status,
      }));
    },
  },
  methods: {
    getLabel(status) {
      switch (status) {
        case STATUS_ANALISE.EM_ANALISE:
          return 'Em análise';
        case STATUS_ANALISE.PENDENTE_DE_ESCLARECIMENTO:
          return 'Esclarecimento';
        case STATUS_ANALISE.ANALISADO:
          return 'Analisado';
        default:
          console.error(`Status de análise "${status}" não está mapeado`);
          return status;
      }
    },
  },
};
</script>
